import {format, formatDate, isValid, parse} from 'date-fns'

const SYS_MIN_DATE = new Date('2022-01-01')

const toIsoDate = ((date: Date) => {
    return format(date, 'yyyy-MM-dd')
})

const friendlyDate = ( date: Date) => {
    return formatDate(date, 'dd.MM.yy')
}

const todayDate = new Date()
const todayYear = todayDate.getFullYear().toString()
const todayMonth = todayDate.getMonth().toString()
const todayDay = todayDate.getDay().toString()

const parseString = (str: string, referenceDate: Date | undefined): Date | undefined => {
    if (!str || str === '' || !referenceDate) return

    const baseFormats = [
        'dd.MM', 'dd.MM.yy', 'dd.MM.yyyy', 'MM.yy', 'MM.yyyy',
        'dd/MM', 'dd/MM/yy', 'dd/MM/yyyy', 'MM/yy', 'MM/yyyy',
        'dd-MM', 'dd-MM-yy', 'dd-MM-yyyy', 'MM-yy', 'MM-yyyy',
        'ddMM', 'ddMMyy', 'ddMMyyyy', 'MMyy', 'MMyyyy',
    ]

    for (const format of baseFormats) {
        const parsedDate = parse(str, format, referenceDate)
        if (isValid(parsedDate)) {
            return parsedDate
        }
    }

    return undefined
}

export {
    parseString,
    toIsoDate,
    friendlyDate,
    SYS_MIN_DATE,
    todayDate,
    todayYear,
    todayMonth,
    todayDay
}